import { useNavigate, useParams } from "react-router-dom";
import { TfiCup } from "react-icons/tfi";
import { RiBookMarkLine } from "react-icons/ri";
import { LuClock4 } from "react-icons/lu";
import { TbDiscount2 } from "react-icons/tb";

import { secondsToTime } from "@/utils/helpers";
import { useFreeOfferRedeem } from "../hooks/useFreeOfferRedeem";
import useIsOfferOwned from "../hooks/useIsLectureOwned";

import Button from "@/components/Button";
import CourseDetail from "./CourseDetail";
import CourseInfo from "./CourseInfo";
import { BiSolidLock } from "react-icons/bi";

function OfferCard({ offer }) {
    const { grade, school_level } = useParams();

    const { id, quizzesCount, videosCount, videosDuration, discount } = offer;
    const { name, brief, price } = offer.attributes;

    const { freeOfferRedeem, isPending } = useFreeOfferRedeem();
    const navigate = useNavigate();

    function handleFreeOffer() {
        freeOfferRedeem(
            { offerId: id },
            {
                onSuccess: () => {
                    navigate(`${school_level}/${grade}/offers/${id}`);
                },
            }
        );
    }
    const { isOwned } = useIsOfferOwned(offer);

    return (
        <div
            className="relative flex flex-col items-center justify-between gap-4 pb-4 my-10 rounded-2xl md:p-6 2xl:flex-row bg-background-color 2xl:gap-0 "
            id={`offer-${id}`}
        >
            {!isOwned && (
                <div className="absolute top-0 p-3 bg-primary-color-primary rounded-tr-xl -right-0">
                    <BiSolidLock className="text-3xl text-white" />
                </div>
            )}
            <div className="flex flex-col items-center justify-center gap-2 p-4 md:gap-8 2xl:flex-row md:p-10">
                {/* img */}
                <div className="w-100">
                    <img
                        src="/images/courses/courseImage.webp"
                        alt="offer icon"
                        className="w-100"
                        loading="lazy"
                        decoding="async"
                    />
                </div>

                <div className="flex flex-col gap-3 text-center 2xl:gap-0 2xl:text-start 2xl:block">
                    {/* name and breif */}
                    <CourseInfo
                        name={name}
                        brief={brief}
                        maxName={10}
                        maxBrief={30}
                    />

                    {/* courseDetail */}
                    <div className="flex flex-wrap items-center justify-center gap-2 px-3 py-2 bg-white md:justify-evenly rounded-2xl">
                        <CourseDetail
                            title={"فيديوهات"}
                            icon={
                                <RiBookMarkLine className="text-lg text-gray-color-primary" />
                            }
                            value={videosCount}
                        />
                        <CourseDetail
                            title={"امتحان"}
                            icon={
                                <TfiCup className="text-lg text-gray-color-primary" />
                            }
                            value={quizzesCount}
                        />
                        <CourseDetail
                            title={"ساعات"}
                            icon={
                                <LuClock4 className="text-lg text-gray-color-primary" />
                            }
                            value={secondsToTime(videosDuration)}
                        />
                        <CourseDetail
                            title={"السعر"}
                            price={price}
                            discount={discount}
                            icon={
                                <TbDiscount2 className="text-xl font-black text-green-color" />
                            }
                            value={`${price}  `}
                        />
                    </div>
                </div>
            </div>

            {isOwned ? (
                <Button
                    type="customized"
                    to={`/${school_level}/${grade}/offers/${id}`}
                    disabled={isPending}
                    className="w-40 text-center py-2  2xl:text-[14px] text-[12px] font-semibold tracking-wide text-white rounded-3xl hover:bg-[#1C3A5C] bg-secondary-color disabled:cursor-not-allowed"
                >
                    الدخول للعرض
                </Button>
            ) : !isOwned && price === 0 ? (
                <Button
                    type="customized"
                    onClick={handleFreeOffer}
                    disabled={isPending}
                    className="w-56 text-center  2xl:text-[14px] text-[12px] font-semibold tracking-wide text-white rounded-3xl py-2 bg-secondary-color hover:bg-[#1C3A5C] disabled:cursor-not-allowed"
                >
                    أشترك الأن
                </Button>
            ) : (
                <Button
                    link1={`/${school_level}/${grade}/offers/${id}`}
                    link1Name={"الدخول للعرض"}
                    link2={"/redeem"}
                    link2Name={"أشترك الأن"}
                />
            )}
        </div>
    );
}

export default OfferCard;
